import { Box, ButtonProps, IconButton, ListItem, ListItemProps, Paper, Popper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { MODAL_WRAPPER_ZINDEX } from '../../../../constants'

export const StyledPopper = styled(Popper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: 0,
  width: '100%',
  left: 0,
  zIndex: MODAL_WRAPPER_ZINDEX,
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))

export const StyledSelectorPaper = styled(Paper)({
  position: 'absolute',
  width: '100%',
  maxHeight: '65vh',
  marginRight: 0,
  maxWidth: '100%',
  background: '#FFFFFF',
  overflowX: 'hidden',
  boxShadow: '0 3.5px 14px rgba(0, 0, 0, 0.2)',
  '&::-webkit-scrollbar': {
    width: '0.5em',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    outline: '1px solid #efefef',
    borderRadius: '0.05em',
  },
})

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  height: 48,
  padding: 0,
  minHeight: 32,
  background: 'none',
  boxSizing: 'border-box',
  position: 'relative',
  borderRadius: 0,
  fontSize: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& svg': {
    position: 'absolute',
    right: 5,
  },
  '& .MuiTypography-root:first-letter': {
    textTransform: 'capitalize',
  },
  [theme.breakpoints.down('xs')]: {
    margin: 0,
  },
}))

export const StyledItem = styled(ListItem)<ListItemProps & ButtonProps>({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  alignContent: 'start',
  position: 'static',
  width: '100%',
  left: '0px',
  top: '48px',
  background: '#FFFFFF',
  justifyContent: 'space-between',
  '& .MuiTypography-displayBlock': {
    marginBottom: '0px',
  },
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
  },
})

export const StyledBoxSelector = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  position: 'relative',
  background: '#FFFFFF',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: 0,
    margin: 0,
  },
}))
